var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuDash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 21,
    viewBox: "0 0 30 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Menu_Dash",
    "data-name": "Menu Dash",
    transform: "translate(-36 -111)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2736",
    "data-name": "Rectangle 2736",
    width: 30,
    height: 5,
    rx: 2.5,
    transform: "translate(36 111)",
    fill: "#fd9543"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2737",
    "data-name": "Rectangle 2737",
    width: 30,
    height: 5,
    rx: 2.5,
    transform: "translate(36 119)",
    fill: "#fd9543"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2738",
    "data-name": "Rectangle 2738",
    width: 30,
    height: 5,
    rx: 2.5,
    transform: "translate(36 127)",
    fill: "#fd9543"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDash);
export default __webpack_public_path__ + "static/media/MenuDash.df9ff4524c88962744aa750baa8cee63.svg";
export { ForwardRef as ReactComponent };